import { apiGet } from '../../api'

export const delete_program = id => {
  return apiGet({
    endpoint: `programs/delete_program?id=${id}`
  })
}
